import { type DisplayUnit } from '@core';

import type { CorridorExtent } from '../../../utils/corridors';

import { RangeLabel } from './RangeLabel/RangeLabel';
import { useTwoCorridorLabelLayout } from './useTwoCorridorLabelLayout';

import type { Corridor } from '../ParameterCardCorridors';

type TwoCorridorLabelsProps = {
    systemCorridor: Corridor;
    goalCorridor: Corridor;
    extent: CorridorExtent;
    unit: DisplayUnit;
    trackWidth: number;
};

export const TwoCorridorLabels = ({
    systemCorridor,
    goalCorridor,
    extent,
    unit,
    trackWidth,
}: TwoCorridorLabelsProps) => {
    const { system, goal, hideSystemStart, hideSystemEnd } = useTwoCorridorLabelLayout({
        systemCorridor,
        goalCorridor,
        extent,
        unit,
        trackWidth,
    });

    return (
        <>
            {hideSystemStart ? null : <RangeLabel {...system.start} />}
            {hideSystemEnd ? null : <RangeLabel {...system.end} />}
            <RangeLabel {...goal.start} />
            <RangeLabel {...goal.end} />
        </>
    );
};
